// Librerias de apoyo
const unirest = require('unirest')
const q = require('q')
const objects = require('./objects')
const detect = require('detect-browser')

export class Engine {
  /**
   * Inicializa un Engine para manejar peticiones con servidores de Medisoft
   * @param {Object} opts Opciones de inicializacion de un Engine para manejar peticiones con servidores de Medisoft
   * @param {objects.Connector} opts.connDev Conexion de modo desarrollo para cuando el motor este en modo desarrollo.
   * @param {objects.Connector} opts.connProd Conexion de modo produccion para cuando el motor este en modo produccion.
   * @param {Object} opts.uris Cadenas que representen los diferentes destinos del API con su respectivo nombre
   * @param {Object} opts.defaultHeaders Objeto que define unos headers por defecto en cada peticion
   * @param {Boolean} opts.useProd Define si desea utilizar la conexion de Produccion o false para definir que se desea usar el modo de desarrollo
   * @param {Function} opts.debugMethod Metodo que registra los movimientos y acciones del motor de solicitudes del API
   * @param {Function} opts.expireSesionMethod Metodo que se ejecuta cuando hay una respuesta de sesion expirada
   */
  constructor (opts) {
    // Asignacion del valor de estado para saber que conexion utilizar
    this.enviroment = opts.useProd
    // Verificamos si se envio dentro de la configuracion de inicializacion los siguientes parametros:
    // Conexion de desarrollo
    this.connDev = opts['connDev'] ? opts.connDev : null
    this.connProd = opts['connProd'] ? opts.connProd : null
    // Libreria de uris
    this.uris = opts['uris'] ? opts.uris : []
    // Headers por defecto
    this.defaultHeaders = opts['defaultHeaders'] ? opts.defaultHeaders : {}
    // Metodo de registro de llamdos del api
    this.debugMethod = opts['debugMethod'] ? opts.debugMethod : null
    /**
     * Obtiene la informacion del cliente que utiliza el motor de datos
     */
    this.GetClientInfo = () => {
      return detect.detect()
    }
    /**
     * Envia un requerimiento al servidor
     * @param {String} uriName Nombre de la uri a utilizar dentro de la coleccion de uris
     * @param {Object} params Parametros a enviar a la solictud dentro del query
     * @param {Object} body Cuerpo de la solicitud a enviar
     * @param {Object} headers Encabezados de la peticion en caso que sean requeridos
     */
    this.SendRequest = (method, uriName, params = null, body = null, headers = null) => {
      // Inicializamos el operador de promesas
      let defer = q.defer()
      // creamos el requerimiento
      // dependiendo del tipo de configuracion
      let req
      // procesos
      if (this.enviroment === true) req = unirest(method, this.connProd.getString() + this.uris[uriName])
      else req = unirest(method, this.connDev.getString() + this.uris[uriName])
      // Definimos el Header del body
      if (body !== null && method !== 'GET' && method !== 'get') headers = Object.assign({}, headers, { 'Content-Type': 'application/json' }, this.defaultHeaders)
      // añadimos los headers
      if (headers !== null) req.headers(headers)
      // añadimos los parametros de la solicitud
      if (params !== null) req.query(params)
      let starTime = Date.now()
      // enviamos el requerimiento
      if (body !== null) req.send(body)
      else req.send()
      // callback al finalizar procesamiento
      req.end((res) => {
        if (res.error) {
          defer.reject(new objects.Result(500, res.error))
        }
        let result = new objects.Result(res.body.code, res.body.exception, res.body.result)
        if (result.code !== 200) {
          if (!this.enviroment) console.log(`Excepcion Engine API ${uriName} :: ${result.code}`, result.exception)
          if (result.code === 601 && opts.expireSesionMethod !== null) opts.expireSesionMethod()
          defer.reject(result)
        }
        else if (result.code === 200) defer.resolve(result)
        // Carga de procesamiento de peticion al debug
        if (this.debugMethod !== null) {
          this.debugMethod({
            verb: method,
            uri: res.url,
            statusCode: result.code,
            responseCode: result.code,
            timing: `${((Date.now() - starTime) / 1000).toFixed(3)}s`,
            query: params,
            body: body,
            exception: result.exception,
            response: result.result
          })
        }
      })
      // retornamos la promesa
      return defer.promise
    }
  }
}
